import React, {useState} from 'react';
import {Button} from '@components';
import {Card, Form, Row, Col, ButtonGroup} from 'react-bootstrap';
import {Formik} from 'formik';
import * as yup from 'yup';
import {useDispatch} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {toast} from 'react-toastify';
import {
    DATE_TIME_REACT_FORMAT,
    DATE_TIME_REACT_WITHOUT_HOUR_FORMAT,
    messageError,
    messageToast,
    objectLoai,
    objectLoaiNoiDung,
    objectTrangThaiDeNghi,
    status200,
    styleSelectDefault,
    styleSelectError
} from '../../utils/define';
import {addEmailConfigAction} from '../../store/reducers/emailConfig';
import ReactSpinner from '../../components/reactSpinner/ReactSpinner';
import {OPENIDDICTAPPLICATION_API, ROLE_API} from '@app/utils/apiUrl';
import {useMutation, useQuery} from 'react-query';
import Editor from '@app/components/editor/Editor';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import {AsyncPaginate} from 'react-select-async-paginate';
import {Get, Post} from '@app/utils/httpProvider';
import HorizontalFieldsRow from '@app/components/common/HorizontalFieldsRow';

const schema = yup.object().shape({
    clientAppId: yup.string().required(messageError.emptyMessage),
    clientAppDisplayName: yup.string().required(messageError.emptyMessage),
    clientDomain: yup.string().required(messageError.emptyMessage),
    apiAppId: yup.string().required(messageError.emptyMessage),
    apiAppSecret: yup.string().required(messageError.emptyMessage),
    apiAppDisplayName: yup.string().required(messageError.emptyMessage),
    scopeName: yup.string().required(messageError.emptyMessage),
    scopeDisplayName: yup.string().required(messageError.emptyMessage),
});

const OpeniddictApplicationAdd = () => {
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);

    const addFunc = useMutation((value) =>
        Post(OPENIDDICTAPPLICATION_API.ADD_ITEM, null, value, false)
    );

    const handleCreate = async (values) => {
        const model = values;

        model.customScope = {
            scopeName: values.scopeName,
            scopeDisplayName: values.scopeDisplayName
        };

        addFunc.mutate(model, {
            onSuccess: (res) => {
                if (res.status !== status200) {
                    toast.error(messageToast.messageToastCreateError);
                } else {
                    setIsLoading(true);
                    toast.success(messageToast.messageToastCreateSuccess);
                    history.goBack();
                }
            },
            onError: (res) => {
                toast.error(
                    res.message || 'Đã có lỗi xảy ra, vui lòng thử lại !'
                );
            }
        });
    };

    const listRole = useQuery(['getAllRolesFromAuthServer'], () =>
        Get(ROLE_API.GET_PAGING, null, {
            PageIndex: 1,
            PageSize: 10000
        })
    );

    const lstRole =
        listRole &&
        listRole.data &&
        listRole.data.data &&
        listRole.data.data.length > 0
            ? listRole.data.data.map((x) => ({
                  name: x.name,
                  id: x.id
              }))
            : [];

    const loadOptions = async (inputValue, loadedOptions, {page}) => {
        const filtered = lstRole
            .filter((o) =>
                o.name.toLowerCase().includes(inputValue.toLowerCase())
            )
            .slice(0, 6);
        return {
            options: filtered,
            hasMore: false,
            additional: {page: page + 1}
        };
    };

    return (
        <Card>
            <Card.Header as="h5">Thêm thông tin ứng dụng SSO</Card.Header>
            <Card.Body>
                <Formik
                    validationSchema={schema}
                    onSubmit={(values) => handleCreate(values)}
                    initialValues={{
                        clientAppId: '',
                        clientAppDisplayName: '',
                        clientDomain: '',

                        apiAppId: '',
                        apiAppSecret: '',
                        apiAppDisplayName: '',

                        scopeName: '',
                        scopeDisplayName: '',
                    }}
                >
                    {({
                        handleSubmit,
                        handleChange,
                        values,
                        errors,
                        setFieldValue
                    }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            <HorizontalFieldsRow
                                fields={[
                                    {
                                        label: 'Mã ứng dụng Client',
                                        name: 'clientAppId',
                                        value: values.clientAppId,
                                        onChange: handleChange,
                                        isInvalid: errors.clientAppId,
                                        error: errors.clientAppId
                                    },
                                    {
                                        label: 'Tên ứng dụng Client',
                                        name: 'clientAppDisplayName',
                                        value: values.clientAppDisplayName,
                                        onChange: handleChange,
                                        isInvalid: errors.clientAppDisplayName,
                                        error: errors.clientAppDisplayName
                                    },
                                    {
                                        label: 'Client Domain',
                                        name: 'clientDomain',
                                        value: values.clientDomain,
                                        onChange: handleChange,
                                        isInvalid: errors.clientDomain,
                                        error: errors.clientDomain
                                    }
                                ]}
                            />
                            <HorizontalFieldsRow
                                fields={[
                                    {
                                        label: 'Mã ứng dụng API',
                                        name: 'apiAppId',
                                        value: values.apiAppId,
                                        onChange: handleChange,
                                        isInvalid: errors.apiAppId,
                                        error: errors.apiAppId
                                    },
                                    {
                                        label: 'Tên ứng dụng API',
                                        name: 'apiAppDisplayName',
                                        value: values.apiAppDisplayName,
                                        onChange: handleChange,
                                        isInvalid: errors.apiAppDisplayName,
                                        error: errors.apiAppDisplayName
                                    },
                                    {
                                        label: 'Mật khẩu ứng dụng API',
                                        name: 'apiAppSecret',
                                        value: values.apiAppSecret,
                                        onChange: handleChange,
                                        isInvalid: errors.apiAppSecret,
                                        error: errors.apiAppSecret
                                    }
                                ]}
                            />
                            <HorizontalFieldsRow
                                fields={[
                                    {
                                        label: 'Tên Scope',
                                        name: 'scopeName',
                                        value: values.scopeName,
                                        onChange: handleChange,
                                        isInvalid: errors.scopeName,
                                        error: errors.scopeName
                                    },
                                    {
                                        label: 'Tên hiển thị Scope',
                                        name: 'scopeDisplayName',
                                        value: values.scopeDisplayName,
                                        onChange: handleChange,
                                        isInvalid: errors.scopeDisplayName,
                                        error: errors.scopeDisplayName
                                    },
                                    {}
                                ]}
                            />
                            <Form.Group as={Row} className="mb-3">
                                <Col md={{span: 10, offset: 2}}>
                                    <ButtonGroup className="mb-2">
                                        <Button
                                            type="submit"
                                            theme="primary"
                                            disabled={isLoading}
                                        >
                                            Thêm
                                        </Button>
                                        &nbsp;&nbsp;&nbsp;
                                        <Button
                                            onClick={() => history.goBack()}
                                            theme="secondary"
                                        >
                                            Hủy
                                        </Button>
                                    </ButtonGroup>
                                </Col>
                            </Form.Group>
                        </Form>
                    )}
                </Formik>
                <ReactSpinner loadings={isLoading} />
            </Card.Body>
        </Card>
    );
};

export default OpeniddictApplicationAdd;
